export const groupPaths = {
  root: 'groups',
  alerts: (groupId: string) => `groups/${groupId}/alerts`,
  newAlert: (groupId: string) => `groups/${groupId}/alerts/new`,
  editAlert: (groupId: string, alertId: string) =>
    `groups/${groupId}/alerts/${alertId}`,
};
